// Which page the "/" route renders.
//   'react' -> containers/HomePage: React sections plus listing feeds.
//   'cms'   -> containers/LandingPage: the Console-managed page (still live at /p/landing-page).
// A code constant rather than an env var because the host's config vars are not in our hands
// (see the MIGRATION OVERRIDE notes in configDefault.js). Flip and deploy to revert.
export const HOME_PAGE_VARIANT = 'react';

// The curated wishlists shown as rows under "Neu auf Toastably", in page order.
// Slugs come from /wishlists/p/<slug>; the row title is the wishlist's own title,
// so renaming one in the app renames the row.
export const HOME_WISHLIST_SLUGS = [
  'hobo-wedding-02c65643', // Wild & Free
  'vip-vibes-0fc98411', // VIP Vibes
  'all-white-39a55da5', // All White
  'luxury-love-e7e919c3', // Luxury Love
];
